import React from 'react';
import PropTypes from 'prop-types';
import utilService from '../../services/UtilService';
import constants from '../../qti/Constants';
import AdditionalResource from '../additionalResourcesBar/AdditionalResource';

class LinkAdditionalResource extends React.PureComponent {
    static propTypes = {
        resource: PropTypes.object.isRequired,
    };

    render() {
        const { link } = this.props.resource;
        let { title } = this.props.resource;

        if (link === title) {
            title = utilService.getDomainFromUrl(link);
        }
        if (!utilService.isSafeUrl(link)) {
            return null;
        }

        return <AdditionalResource url={link} title={title} type={constants.additionalResourceType.LINK} />;
    }
}

export default LinkAdditionalResource;
